import React, { useState, useEffect } from 'react';
import { apiServices } from '../../../services/apiServices';
import { Configuration } from '../../../assets/data/config';
import Swal from 'sweetalert2';

const VersionCheck = () => {
  const [versionInfo, setVersionInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const checkVersion = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await apiServices.getAPI('version/current');
      
      if (window.cordova && response && response.status >= 200 && response.status < 300) {
        const data = response.data;
        
        if (data.success && data.data) {
          setVersionInfo(data.data);
          
          // Compare versions
          const currentVersion = Configuration.mobileAppVersion;
          const serverVersion = data.data.version_number;
          
          if (currentVersion < serverVersion) {
            // Show SweetAlert for update
            Swal.fire({
              title: 'Update Available!',
              text: `A new version of the app is ready. Please update to continue.`,
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Update Now',
              cancelButtonText: 'Later',
              confirmButtonColor: '#1976d2',
              cancelButtonColor: '#6c757d',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                // Use the download URL from the API response
                const downloadUrl = Configuration.mobileAppDownloadUrl;
                window.open(downloadUrl, '_blank');
              }
            });
          }
        }
      } else {
        setError('Failed to fetch version information');
      }
    } catch (err) {
      console.error('Error checking version:', err);
      setError('Error checking for updates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkVersion();
  }, []);

  // Don't render anything - just show SweetAlert
  return null;
};

export default VersionCheck;
